import React from 'react';
import { Form, Input, Button, message } from 'antd';
import { ServicetypeService } from '../../../Services/Manage/ServicetypeService';
import useMessage from 'antd/es/message/useMessage';
import { UserService } from '../../../Services/Manage/UserService';

const AddProductCat = ({  initialValues, onSubmit, onCancel }) => {
    const [form] = Form.useForm();
    const [message, messagecontxt] = useMessage();

    const handleFinish = async (values) => {
        try {

            const user = await UserService.getOmeUser();
            const payload = {
                ...values,
                added_by: user.uid,
                updated_on: new Date().toISOString().slice(0, 16).replace("T", " "),
                added_on: new Date().toISOString().slice(0, 16).replace("T", " "),
            };

            if (initialValues?.id) {
       
                const payload = { ...values, added_by: user.uid, updated_on: new Date().toISOString().slice(0, 16).replace("T", " ") };

                const req = await ServicetypeService.updateProductCat(payload, initialValues.id,);
   

                if (req.status) {
                    message.success(req.message)
                    onSubmit(values);
                    form.resetFields();
                } else {
                    message.error(req.message)
                }

            } else {
                const req = await ServicetypeService.createProductCat(payload);
         
                if (req.status) {
                    message.success(req.message)
                    onSubmit(payload);
                    form.resetFields();
                } else {
                    message.error(req.message)
                }
            }


        } catch (error) {
            console.error("Service operation failed:", error);
        }
    };
    return (
        <Form
            form={form}
            layout="vertical"
            initialValues={initialValues || {}}
            onFinish={handleFinish}
        >
            <Form.Item
                name="name"
                label="Category Name"
                rules={[{ required: true, message: 'Please enter category name' }]}
            >
                <Input size='large' />
            </Form.Item>


            <div style={{ textAlign: 'right' }}>
                <Button onClick={onCancel} style={{ marginRight: 8 }} size='large'>
                    Cancel
                </Button>
                <Button type="primary" htmlType="submit" size='large'>
                    {initialValues ? 'Update' : 'Add'}
                </Button>
                {messagecontxt}
            </div>
        </Form>
    );
};

export default AddProductCat;
